import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { COOKIE_PARENT_DOMAIN } from '@/helpers/locale';
import hashMap from '../locales-hash.json';

export const DEFAULT_LOCALE = 'en';
export const LOCALES = ['en', 'el', 'es', 'pt', 'de', 'nl', 'et'];

const namespaces = [
  'affiliate',
  'auth',
  'bank_accounts',
  'blog',
  'brands',
  'calculator',
  'client_questions',
  'common',
  'compliance',
  'compliant',
  'components',
  'constants',
  'containers',
  'dashboard',
  'dynamic',
  'footer',
  'funds',
  'help',
  'investing',
  'kit',
  'loan_terms',
  'loans',
  'loyalty',
  'modal',
  'navigation',
  'profile',
  'repayment_schedule',
  'reports',
  'round_history',
  'streak',
  'utils',
  'validation',
  'veriff',
  'warning',
  'withdraw',
];

i18n
  .use(HttpApi) // Load translations via HTTP
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Bind React-i18next
  .init({
    fallbackLng: DEFAULT_LOCALE, // Default language
    supportedLngs: LOCALES, // List of supported languages
    debug: false, // Enable console logs for debugging
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    ns: namespaces, // Namespaces
    defaultNS: 'common',
    backend: {
      loadPath: (lng, ns) => {
        const hash = getHashForNamespace(lng, ns);
        const cdnUrl = import.meta.env.VITE_CDN_URL || '';
        return `${cdnUrl}/locales/${lng}/${ns}_${hash}.json`;
      },
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator'],
      caches: ['cookie', 'localStorage'], // Cache the language
      lookupCookie: 'preferredLanguage',
      cookieDomain: COOKIE_PARENT_DOMAIN, // Set domain for cookie
    },
  });

function getHashForNamespace(lng, ns) {
  return hashMap[lng] && hashMap[lng][ns] ? hashMap[lng][ns] : '';
}

export default i18n;
